export default __webpack_public_path__ + "static/media/fig-19-fault-proposed.a24233ea.png";